module.exports = __webpack_public_path__ + "img/volume.daad607d.svg";